import React from 'react';
import { useTranslation } from 'react-i18next';
import _startCase from 'lodash/startCase';
import { StatTab } from '@m12s/component-library';
import { useSelector } from 'react-redux';

import { DurationTicker } from 'components/DurationTicker';
import { formatValue } from 'lib/utils/text';
import { getJobStatus } from 'lib/selectors/getJobStatus';
import { getHasOpenActivitySetInSetup } from 'lib/selectors/getHasOpenActivitySetInSetup';
import { getAdjustedSetupDurationDates } from 'lib/selectors/getAdjustedSetupDurationDates';
import { getLatestSetupActivityEndAt } from 'lib/selectors/getLatestSetupActivityEndAt';
import { getArePartCountBucketsLoading } from 'lib/selectors/getPartCountBuckets';

import { getProductionPartsDisplay } from 'lib/selectors/getProductionPartsDisplay';
import {
  TextMedia,
  LoadingStatTabLabel,
  LoadingStatTabSecondaryLabel,
} from '../styled';
import { DURATION_FORMAT, DURATION_OPTIONS } from './constants';

export const PartCountTab = () => {
  const { t } = useTranslation();

  const { displayParts } = useSelector(getProductionPartsDisplay);

  const jobStatus = useSelector(getJobStatus);
  const hasOpenActivitySetInSetup = useSelector(getHasOpenActivitySetInSetup);
  const { adjustedSetupStartDate } = useSelector(getAdjustedSetupDurationDates);
  const setupActivityEndAt = useSelector(getLatestSetupActivityEndAt);

  const arePartCountBucketsLoading = useSelector(getArePartCountBucketsLoading);

  return hasOpenActivitySetInSetup || jobStatus === 'setup' ? (
    <StatTab
      id="part-count-tab"
      value="partCount"
      label={t('Setup')}
      secondaryLabel={
        adjustedSetupStartDate && (
          <DurationTicker
            startDate={adjustedSetupStartDate}
            endDateOverride={setupActivityEndAt}
            format={DURATION_FORMAT}
            formatOptions={{ ...DURATION_OPTIONS, trim: 'small' }}
          />
        )
      }
    />
  ) : (
    <StatTab
      id="part-count-tab"
      value="partCount"
      label={
        <LoadingStatTabLabel loading={arePartCountBucketsLoading}>
          <TextMedia max={60}>{_startCase(t('parts'))}</TextMedia>
          <TextMedia min={60}>{_startCase(t('part count'))}</TextMedia>
        </LoadingStatTabLabel>
      }
      secondaryLabel={
        arePartCountBucketsLoading ? (
          <LoadingStatTabSecondaryLabel />
        ) : (
          formatValue(displayParts, (parts) => {
            return parts?.toLocaleString();
          })
        )
      }
    />
  );
};
